module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "customer-list-wrapper"
    }
  }, [_c('v-layout', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "id": "customer-sort-box",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "sm1": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "ml-4 mt-3",
    attrs: {
      "hide-details": "",
      "indeterminate": _vm.checkboxIndeterminate
    },
    on: {
      "click": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "naive", undefined, $event.key)) { return null; }
        _vm.toggleAll($event)
      }
    },
    model: {
      value: (this.locations.length > 0 && this.selectedLocations.length === this.locations.length),
      callback: function($$v) {
        _vm.$set(this.locations.length > 0 && this.selectedLocations.length === this.locations, "length", $$v)
      },
      expression: "this.locations.length > 0 && this.selectedLocations.length===this.locations.length"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2 search",
    attrs: {
      "xs5": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.listSearch),
      callback: function($$v) {
        _vm.listSearch = $$v
      },
      expression: "listSearch"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm7": ""
    }
  }, [(_vm.userRole === _vm.viewerRoleName) ? _c('span', {
    staticClass: "caption hidden-xs-only orange--text"
  }, [_vm._v(_vm._s(_vm.$t('account.function-limit')))]) : _vm._e(), _vm._v(" "), (_vm.userRole !== _vm.viewerRoleName) ? _c('customer-add-btn', {
    ref: "customerDialog",
    on: {
      "child-action": _vm.showMessage
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "id": "customer-list-main",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm5": "",
      "id": "customer-list"
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.listHeaders,
      "items": _vm.filteredLocations,
      "select-all": "",
      "disable-initial-sort": "",
      "hide-headers": "",
      "pagination": _vm.pagination,
      "item-key": "locationId"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left body-1"
        }, [_vm._v(_vm._s(props.item.locationName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right caption grey--text text--darken-2"
        }, [_vm._v("\n                " + _vm._s(props.item.organizationName) + "\n            ")])])]
      }
    }]),
    model: {
      value: (_vm.selectedLocations),
      callback: function($$v) {
        _vm.selectedLocations = $$v
      },
      expression: "selectedLocations"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "grey lighten-3",
    attrs: {
      "xs12": "",
      "sm7": "",
      "id": "customer-detail"
    }
  }, [((_vm.selectedLocations.length > 0 || _vm.initDisplayLocations.length > 0)) ? _c('v-tabs', {
    staticClass: "white mt-3",
    attrs: {
      "fixed-tabs": "",
      "hide-slider": ""
    }
  }, [_c('v-tab', {
    staticClass: "white",
    attrs: {
      "href": "#customer-info"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customer.info')) + "\n        ")]), _vm._v(" "), _c('v-tab-item', {
    staticClass: "white",
    attrs: {
      "id": "customer-info"
    }
  }, _vm._l((_vm.initOrSelectedLocations), function(location) {
    return _c('v-card', {
      key: location.locationId,
      staticClass: "ma-2 pl-3"
    }, [_c('v-card-title', {
      staticClass: "align-baseline pa-0"
    }, [_c('h2', [_vm._v(_vm._s(location.locationName) + "    ")]), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v(" " + _vm._s(location.organizationName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.userRole !== _vm.rootRoleName && _vm.userRole !== _vm.viewerRoleName) ? _c('div', [_c('v-menu', {
      attrs: {
        "left": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "small": "",
        "flat": "",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', {
      staticClass: "caption grey--text"
    }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.editCustomer(location)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('btn.edit')) + "\n                  ")]), _vm._v(" "), _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.deleteTarget = location;
          _vm.showDeleteDialog = true
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('btn.delete')) + "\n                  ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n                " + _vm._s(_vm.$t('customer.active-device')) + ":\n                " + _vm._s(location.activeDevices) + "\n              ")]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
      staticClass: "cutomer-info pl-2",
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.address')))]), _vm._v("\n                  " + _vm._s(location.locationAddress) + "\n                ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "cutomer-info pl-2",
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.contact')))]), _vm._v(" "), _c('div', [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("local_phone")]), _vm._v("\n                    " + _vm._s(location.locationPhone) + "\n                  ")], 1), _vm._v(" "), _c('div', [_c('v-icon', {
      staticClass: "body-1"
    }, [_vm._v("mail_outline")]), _vm._v("\n                    " + _vm._s(location.locationEmail) + "\n                  ")], 1)]), _vm._v(" "), _c('v-flex', {
      staticClass: "cutomer-info pl-2",
      attrs: {
        "xs12": "",
        "md4": ""
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('customer.others')))]), _vm._v("\n                  " + _vm._s(_vm.$t('customer.geo-location')) + ": \n                  "), (location.latitude) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.$t('customer.defined')) + "\n                  ")]) : _c('span', [_vm._v("\n                    " + _vm._s(_vm.$t('customer.undefined')) + "\n                  ")])])], 1)], 1)], 1)
  }))], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-title')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('account.caution-location-remove-text'))), _c('br'), _c('br'), _vm._v("\n        " + _vm._s(_vm.deleteTarget.locationName) + "\n        (" + _vm._s(_vm.deleteTarget.organizationName) + ")"), _c('br')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteCustomer($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.delete')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('account.cancel')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "relative": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbarMessage) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-b1b32b0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerList.vue
// module id = 1946
// module chunks = 0